// @pipeline-trigger 2026-04-02v5 - CI fix: standalone workflow with root install
import('./bootstrap');
